import type { SidebarNav } from '@/shared/ui';

export const SIDEBAR_NAV: SidebarNav[] = [
  { key: 'dashboard', icon: 'grid', label: 'Dashboard' },
  { key: 'elva-work', icon: 'bolt', label: 'ELVA’s work' },
  { key: 'human-in-the-loop', icon: 'worklist', label: 'Human in the loop' },
  { key: 'calendar', icon: 'calendar', label: 'Calendar' },
  { key: 'patients', icon: 'team', label: 'Patients' },
  { key: 'live-check', icon: 'bolt', label: 'Live Check' },
  { key: 'claims', icon: 'doc', label: 'Claims' },
  { key: 'ar', icon: 'clock', label: 'Insurance A/R' },
  { key: 'denied', icon: 'doc', label: 'Denied & underpaid', countTone: 'alert' },
  { key: 'pre-auths', icon: 'preauth', label: 'Pre-Auths' },
  { key: 'posting', icon: 'posting', label: 'Posting' },
  { key: 'document-center', icon: 'folder', label: 'Document Center' },
  { key: 'settings', icon: 'cog', label: 'Settings' },
];

export const NAV_PATHS: Record<string, string> = {
  dashboard: '/dashboard',
  'elva-work': '/elva-work',
  calendar: '/calendar',
  patients: '/patients',
  'live-check': '/live-check',
  'human-in-the-loop': '/human-in-the-loop',
  claims: '/claims',
  denied: '/denied',
  'pre-auths': '/pre-auths',
  posting: '/posting',
  ar: '/ar',
  'document-center': '/document-center',
  settings: '/settings',
};

export const OPS_NAV_KEYS = ['claims', 'pre-auths', 'posting', 'ar'] as const;

export function getNavKeyFromPath(pathname: string): string {
  if (pathname.startsWith('/settings')) return 'settings';
  if (pathname.startsWith('/patients')) return 'patients';
  if (pathname.startsWith('/live-check')) return 'live-check';
  if (pathname.startsWith('/claims')) return 'claims';
  if (pathname.startsWith('/ar') || pathname.startsWith('/sent-claims')) return 'ar';
  if (pathname.startsWith('/denied')) return 'denied';
  if (pathname.startsWith('/pre-auths')) return 'pre-auths';
  if (pathname.startsWith('/posting')) return 'posting';
  if (pathname.startsWith('/elva-work')) return 'elva-work';
  if (pathname.startsWith('/document-center')) return 'document-center';
  if (pathname.startsWith('/human-in-the-loop') || pathname.startsWith('/worklist')) return 'human-in-the-loop';
  const match = Object.entries(NAV_PATHS).find(([, path]) => path === pathname);
  return match?.[0] ?? 'dashboard';
}
